import React, { useCallback, useEffect, useRef, memo } from 'react';
import * as echarts from 'echarts';
// @ts-ignore
import { isEqual, debounce } from 'lodash-es';
import './index.scss';

const resizeRenderEchart = (chartEle: any) => {
  const myChart: any = echarts.getInstanceByDom(chartEle);
  // const option = myChart.getOption();
  // myChart.setOption(option);
  myChart.resize();
};

interface BaseEchartPropsTypes {
  echartsBoxStyle?: React.CSSProperties;
  echartsOptions: any;
  refresh?: any; // 这个值一定是变化的, 变化了echart就会刷新渲染
  onInit?: (chartInstance: any, chartDom: any) => void;
}

const DEFAULT_PROPS: BaseEchartPropsTypes = {
  echartsBoxStyle: {},
  echartsOptions: null,
  refresh: null,
};

const BaseEchart: React.FC<BaseEchartPropsTypes> = (props) => {
  const { echartsBoxStyle, echartsOptions, refresh, onInit } = props;

  const chartRef = useRef(null);

  // 监听屏幕变化，重绘图表
  const listenerResize = useCallback((chart: any) => {
    if (chart) debounce(() => resizeRenderEchart(chart), 300);
  }, []);

  // 初始化图表，设置配置项
  const renderChart = useCallback(() => {
    if (chartRef.current) {
      let myChart = echarts.getInstanceByDom(chartRef.current);
      if (myChart === null || myChart === undefined) {
        myChart = echarts.init(chartRef.current);
        onInit?.(myChart, chartRef.current);
      }

      echartsOptions && myChart.setOption(echartsOptions, true);
      myChart.resize();

      // 监听屏幕变化事件 传入当前chart实例
      window.addEventListener('resize', () => listenerResize(chartRef.current));
    }
  }, [echartsOptions]);

  // 初始化
  useEffect(() => {
    renderChart();

    return () => {
      // if (chartRef.current) {
      //   (echarts.getInstanceByDom(chartRef.current) as echarts.ECharts).dispose();
      //   window.removeEventListener('resize', listenerResize as EventListenerOrEventListenerObject);
      // }
    };
  }, [echartsOptions]);

  // 手动执行更新
  useEffect(() => {
    if (!refresh) return;
    if (chartRef.current) resizeRenderEchart(chartRef.current);
  }, [refresh]);

  useEffect(() => {
    return () => {
      if (chartRef.current) {
        (echarts.getInstanceByDom(chartRef.current) as echarts.ECharts).dispose();
        window.removeEventListener('resize', listenerResize as EventListenerOrEventListenerObject);
      }
    };
  }, []);

  return (
    <div
      className='dbi-global-view-chart'
      ref={chartRef}
      style={Object?.assign(
        {
          width: '100%',
          height: '100%',
        },
        echartsBoxStyle || {},
      )}
    ></div>
  );
};

BaseEchart.defaultProps = DEFAULT_PROPS;

export default memo(BaseEchart, (prevProps: any, nextProps: any) => isEqual(prevProps, nextProps));
